import ContractTab from './ContractTab.vue';

export default ContractTab;
